import React from 'react';
import InteractiveGallery from './InteractiveGallery';

function App() {
  return <InteractiveGallery />;
}

export default App;